import { errorLogger } from '../lib'

/**
 * Player analytics logger (error-focused in production).
 */
export const logger = errorLogger('player')

export type PlayStartReason = keyof typeof PlayStartReason
export const PlayStartReason = {
  bufferFull: 'bufferFull', // auto
  userPlay: 'userPlay', // default for play_start
  userMove: 'userMove', // rewind or fastforward
  userMoveIntro: 'userMoveIntro', // skip intro button
  userMoveCredits: 'userMoveCredits', // skip credits button
  appUp: 'appUp', // app wake up
  userCast: 'userCast', // casting the video
  userPip: 'userPip', // pip mode
  autoPlay: 'autoPlay', // next content play
  userClick: 'userClick', // click to another content or switching to live
  advertisingStop: 'advertisingStop', // the adds has been stopped
  changeBitrate: 'changeBitrate', // user change bitrate by hand
  changeAudio: 'changeAudio', // user change audiotrack by hand
  autoPreview: 'autoPreview', // for auto‑started trailers only
} as const

export type PlayStopReason = keyof typeof PlayStopReason
export const PlayStopReason = {
  userPause: 'userPause', // default for play_stop
  userMove: 'userMove', // rewind
  userMoveIntro: 'userMoveIntro', // skip intro button
  userMoveCredits: 'userMoveCredits', // skip credits button
  userBack: 'userBack', // click on back button
  userClick: 'userClick', // switched to another content
  userCast: 'userCast', // start cast via airplay or chromecast
  userPip: 'userPip', // enter/exit picture-in-picture
  streamEnd: 'streamEnd', // stream is ended
  streamBuffering: 'streamBuffering', // buffering is in progress
  appHide: 'appHide', // hide app
  streamError: 'streamError', // in case of any stream errors
  advertisingStart: 'advertisingStart', //
  changeBitrate: 'changeBitrate', // user change bitrate by hand
  changeAudio: 'changeAudio', // user change audiotrack by hand
  userScroll: 'userScroll', // trailer stop due to scroll out of scope
  userExit: 'userExit', // exit from module/details with trailer
  otherContent: 'otherContent', // trailer stop due to start of other content
} as const
